<template>
    <div class="container-render-post">
        <div :class="'render-post hide-scrollbar render-post-instagram '+modes.join(' ')">
            <div class="header-app">
                Publication
            </div>
            <div class="post-content">
                <div class="post-header">
                    <div class="info">
                        <div class="img-pages">
                            <template v-for="(picturePage, index) in picturePages.slice(0,picturePages.length == 4 ? 4 : 3)" >
                                <Tooltip :active="picturePage.iconEdited" :key="index" :text="'Voir les modifications apportées'" position="right" :classCustom="`page ${picturePage.iconEdited ? 'iconEdited' : ''}`" @click="()=>{$emit('clickPage', picturePage.id)}">
                                    <img :src="picturePage && picturePage.avatar ? picturePage.avatar : 'img/avatar.jpg'" alt="">
                                </Tooltip>
                            </template>
                        
                            <div class="page count" v-if="picturePages.length > 4">
                                +{{ picturePages.length - 3 }}
                            </div>
                        </div>
                    
                        <p class="name" v-if="picturePages.length == 1">{{ pageName }}</p>
                        <i class="fa-solid fa-circle"></i>
                        <p class="date">{{ datePost ? formatDatePost : 'A l\'instant' }} </p>
                    </div>
                    <div class="more"><i class="fa-solid fa-ellipsis"></i></div>
                </div>
                <div class="post-medias">
                    <div class="carousel" :class="{singleMedia:medias.length == 1}" @mousedown="mouseDownOnPost"  @mouseup="mouseUpOnPost" @click="clickOnPost" :style="{'aspect-ratio' : medias.length == 1 ? ratio.replace(':','/') : '1/1'}">
                        <div v-for="person in personsIdentified" v-if="medias[slideIndexCarousel].id == person.idFile || (slideIndexCarousel == 0 && !medias.some(media => media.id == person.idFile))" :class="`personIndentifed ${getClassForPersonIndentifed(person.x,person.y)} ${showTagPersonIndentifed ? 'show' : 'hide'}`" :style="{left: `${person.x}%`,top: `${person.y}%`}" :key="person.name || person.id">
                            {{person.name || person.id}}
                        </div>

                        <carousel :perPage="1" :adjustableHeight="true" :centerMode="true" @pageChange="slideChangeCarousel" >
                            <Slide v-for="media in medias.slice(0,20)" :key="media.id">
                                <div class="item">
                                    <template v-if="['video/mp4'].includes(media.type)">
                                        <video muted playsinline autoplay loop preload="metadata" class="video" onloadedmetadata="this.muted = true">
                                            <source :src="media.url" type="video/mp4">
                                        </video>
                                    </template>
                                    <img v-else :src="media.url" alt="">
                                </div>
                            </Slide>
                        </carousel>
                    </div>
                </div>
                <div class="post-footer">
                    <div class="like">
                        <svg height="100%" viewBox="0 0 24 24" width="100%"><path d="M16.792 3.904A4.989 4.989 0 0 1 21.5 9.122c0 3.072-2.652 4.959-5.197 7.222-2.512 2.243-3.865 3.469-4.303 3.752-.477-.309-2.143-1.823-4.303-3.752C5.141 14.072 2.5 12.167 2.5 9.122a4.989 4.989 0 0 1 4.708-5.218 4.21 4.21 0 0 1 3.675 1.941c.84 1.175.98 1.763 1.12 1.763s.278-.588 1.11-1.766a4.17 4.17 0 0 1 3.679-1.938m0-2a6.04 6.04 0 0 0-4.797 2.127 6.052 6.052 0 0 0-4.787-2.127A6.985 6.985 0 0 0 .5 9.122c0 3.61 2.55 5.827 5.015 7.97.283.246.569.494.853.747l1.027.918a44.998 44.998 0 0 0 3.518 3.018 2 2 0 0 0 2.174 0 45.263 45.263 0 0 0 3.626-3.115l.922-.824c.293-.26.59-.519.885-.774 2.334-2.025 4.98-4.32 4.98-7.94a6.985 6.985 0 0 0-6.708-7.218Z"></path></svg>
                    </div>
                    <div class="comment">
                        <svg height="100%" viewBox="0 0 24 24" width="100%"><path d="M20.656 17.008a9.993 9.993 0 1 0-3.59 3.615L22 22Z" fill="none" stroke="#000000" stroke-linejoin="round" stroke-width="2"></path></svg>
                    </div>
                </div>
                <div class="description" v-if="text">
                    <!-- <div class="img-pages">
                        <div class="page">
                            <img :src="!picturePages || !picturePages.length || picturePages.length > 1 || !picturePages[0] ?  'img/avatar.jpg' : picturePages[0].avatar" alt="">
                        </div>

                    </div> -->
                    <div class="content">
                    
                        <p class="text">
                            <span class="page-name">{{ picturePages.length > 1 ? 'Autheur' : pageName}}</span>
                            <span v-html="textTranslateMentionAndHastag"></span>
                        </p>
                    </div>
                </div>
                <div class="first-comment" v-if="comment">
                    <div class="img-pages">
                        <div class="page">
                            <img :src="!picturePages || !picturePages.length || picturePages.length > 1 || !picturePages[0] ?  'img/avatar.jpg' : picturePages[0].avatar" alt="">
                        </div>
                        <!-- <div class="page count" v-if="picturePages.length > 3">
                            +{{ picturePages.length - 3 }}
                        </div> -->
                    </div>
                    <div class="content">
                        <p class="page-name">{{ picturePages.length > 1 ? 'Autheur' : pageName}}</p>
                        <p class="text" v-html="commentTranslateMentionAndHastag"></p>
                    </div>
                    <i class="fa-regular fa-heart"></i>
                </div>
            </div>
        </div>



        <SelectPerson v-if="modes.includes('addIdentifierMode')"
            :personsSelect="personsIdentified"
            :positionClick="paramsContentOverflow.identify.positionClick"
            :position="positionFormOverlay"
            @close="closeContentOverflow"
            @resetPositionClick="resetClick"
            
        />
        <SelectPerson v-if="modes.includes('addCollaboratorMode')"
            :personsSelect="collaborators"
            :positionClick="paramsContentOverflow.identify.positionClick"
            :position="positionFormOverlay"
            @close="closeContentOverflow"
            @resetPositionClick="resetClick"
        />
    
        <SelectPlace v-if="modes.includes('addPlaceMode')" 
            @close="closeContentOverflow"
            :placeSelected="place"
            :position="positionFormOverlay"
            :network="'instagram'"
        />
        <SelectMusic v-if="modes.includes('addMusicMode')" 
            @close="closeContentOverflow" 
            :musicSelected="music"
            :position="positionFormOverlay"
        />
    </div>
    
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { Carousel, Slide } from 'vue-carousel';
    import SelectMusic from '../formOverlay/selectMusic.vue';
    import SelectPlace from '../formOverlay/selectPlace.vue';
    import SelectPerson from '../formOverlay/selectPerson.vue';
    import Tooltip from '../../tooltip/tooltipInit.vue'

    export default {
        components: {
            Carousel,
            Slide,
            SelectMusic,
            SelectPlace,
            SelectPerson,
            Tooltip
        },

        props: {
            picturePages: {
                type: Array,
                default: ()=>[] 
            },
            pageName : {
                type: String,
                default: ''
            },
            datePost: {
                default: 1315349759920 
            },
            text : {
                type: String,
                default: ''
            },
            comment : {
                type: String,
                default: ''
            },
            medias: {
                type: Array,
                default: ()=>[] 
            },   
            personsIdentified: {
                type: Array,
                default: ()=>[] 
            },
            collaborators: {
                type: Array,
                default: ()=>[] 
            },
            place: {
                type: Object,
                default: undefined
            },
            music: {
                type: Object,
                default: undefined
            },
            ratio : {
                type: String,
                default: '1:1'
            },
            modes: {
                type: Array,
                default: ()=>[] 
            },
            mentions : {
                type: Object,
                default: ()=>({})
            },
            positionFormOverlay: {
                type: String,
                default: 'left'
            },

            
            

        },
        
        data() {
            return {
                paramsContentOverflow : {
                    identify : {
                        positionClick : undefined,
                        lastMouseDownEvent: {}
                    },
                    // place : {
                    //     steep : 1,
                    // },
                    // music : {
                    //     steep : 1,
                    // }
                },
                slideIndexCarousel : 0,
                showTagPersonIndentifed : true
                
                
               
            }
        },

        methods: {
            mouseDownOnPost(e) {
                this.showTagPersonIndentifed = false
                this.paramsContentOverflow.identify.lastMouseDownEvent = {
                    clientX : e.clientX,
                    clientY : e.clientY
                }
            },

            mouseUpOnPost() {
                this.showTagPersonIndentifed = true
            },
            clickOnPost(e) {
                if (e.target.type !== 'button' && Math.abs(e.clientX - this.paramsContentOverflow.identify.lastMouseDownEvent.clientX) < 3 && Math.abs(e.clientY - this.paramsContentOverflow.identify.lastMouseDownEvent.clientY) < 3) {
                    const parentRect = e.currentTarget.getBoundingClientRect();

                    this.paramsContentOverflow.identify.positionClick = {
                        x : (e.clientX - parentRect.left) / parentRect.width * 100,
                        y : (e.clientY - parentRect.top) / parentRect.height * 100,
                        idFile : this.medias[this.slideIndexCarousel].id
                    }
                }
            },

            resetClick() {
                this.paramsContentOverflow.identify.positionClick = undefined
            },

            slideChangeCarousel(index) {
                this.showTagPersonIndentifed = true
                this.slideIndexCarousel = index
            },
            closeContentOverflow() {
                EventBus.$emit('postCreatorRemoveMode', 'all')
                this.resetClick()
            },

            getClassForPersonIndentifed(x,y) {
                let tab = []
                if (y > 80) tab.push('bottom');
                else if (y < 20) tab.push('top');
                if (x > 80) tab.push('right');
                else if (x < 20) tab.push('left');
                return tab.join('-')
            },

            carouselPageChange(slideIndex) {
                
            },

            carouselTransitionStart() {
                console.log("carouselTransitionStart")
            },

            carouselTransitionEnd() {
                console.log("carouselTransitionEnd")
            }

        },

        computed: {
            formatDatePost: function(){
                if(this.datePost == false) return '';
                let dateNow = new Date()
                let dateFuture = new Date(this.datePost)

                const addHours = (dateString) => (`${dateString} à ${dateFuture.getHours()}h${dateFuture.getMinutes().toString().padStart(2, '0')}`)
        
                if (dateFuture.getFullYear() === dateNow.getFullYear()) {
                    if (Math.abs(Math.ceil(Math.abs(dateFuture-dateNow) / (1000 * 60 * 60 * 24))) < 7) {
                        if (dateFuture.getDay() === dateNow.getDay()) return addHours("Aujourd'hui")
                        if (dateFuture.getDay() === dateNow.getDay()+1) return addHours("Demain")
                        if (dateFuture.getDay() === dateNow.getDay()-1) return addHours("Hier")
                        return addHours(dateFuture.toLocaleDateString(undefined, { weekday: 'long' }));
                    }
                
                    if(dateFuture.getMonth() === dateNow.getMonth()) return addHours(dateFuture.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric'}));

                    return addHours(dateFuture.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'numeric' }));
                }
                return addHours(dateFuture.toLocaleDateString(undefined, { day: 'numeric', month: 'numeric', year: 'numeric' }));
            },

            textTranslateMentionAndHastag() {
                //return this.text
                return this.text.replace(/#\w+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.instagram ? `<span class="mention">@${mention.mention.instagram.id || mention.mention.instagram.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            },

            commentTranslateMentionAndHastag() {
                //return this.text
                return this.comment.replace(/#\w+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.instagram ? `<span class="mention">@${mention.mention.instagram.id || mention.mention.instagram.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            }
        },
    }
</script>
